import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { Product } from 'src/models/DTO/products/product';
import { Reviews } from 'src/models/DTO/reviews/reviewCollection';
import { UserDTO } from 'src/models/DTO/user/user';
import { CreateReviewRequestModel } from 'src/models/requestModels/reviews/createReviewRequestModel';
import { ToastService } from 'src/services/core/toast/toast.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { ProductService } from 'src/services/request/product/product.service';
import { RatingsService } from 'src/services/request/ratings/ratings.service';
import { ReviewsService } from 'src/services/request/reviews/reviews.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-makereview',
  templateUrl: './makereview.component.html',
  styleUrls: ['./makereview.component.css']
})
export class MakereviewComponent extends HistoryBaseComponent implements OnInit {

  selectedOrder: string = "Най-нови";
  selectedFilter: string = "Всички";

  private _order?: CreatedOrder;
  private _crurrentReviews: Reviews = { data: [] };
  private _loggedUser?: UserDTO
  private _reviewForms: { [key: string]: FormGroup } = {};


  constructor(
    private ordersService: OrderService,
    private imagesService: ImagesService,
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private reviewsService: ReviewsService,
    private ratingsService: RatingsService,
    private userStateService: LoggedUserService,
    private toastr: ToastService,
    private FB: FormBuilder,
    protected location: Location,
    protected historyService: HistoryService
  ) { 
    super(location, historyService);
    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.loadOrder(params.id);
    })
  }

  private loadOrder(orderUUID: string) {
    this.ordersService.getOrder(orderUUID).subscribe(order => {
      this._order = order;
      order.data.lines.forEach(product => {
        this.imagesService.getImagesForProduct("PRODUCT", product.sku.product.uuid).subscribe(images => {
          product.imageSource = images.data[0].original.url
        })
        this.ratingsService.getRatingsPerProduct(product.sku.product.uuid).subscribe(reviews => {
          if (reviews.data.find(review => review.user.uuid == this._loggedUser?.data.uuid)) {
            this._order!.data.lines = this._order!.data.lines.filter(line => line.uuid != product.uuid)
          }
        })
        this._reviewForms[product.uuid] = this.FB.group({
          rating: [0, [Validators.required]],
          review: ['']
        })
      })
    })
  }

  private removeReviewedCartLine(reviewedCartLineUUID: string) {
    this._order!.data.lines = this._order!.data.lines.filter(cartLine => cartLine.uuid != reviewedCartLineUUID)
  }

  get order() {
    return this._order?.data.lines || [];
  }

  get reviewForms() {
    return this._reviewForms;
  }

  returnOptionValue(option: any) {
    if (option.option.values.length) {
      let optionSelected = option.option.values.find((value: { uuid: any; }) => value.uuid == option.value);
      return optionSelected.value;
    }
    return option.value;
  }

  pricingInfo(cartLine: CartLine) {
    let price = cartLine.price_per_piece;
    let priceAsString =  Number.parseFloat(price).toFixed(2);
    return  cartLine.quantity + ' x ' + priceAsString + ' лв.';
  }

  getPriceAsFixedString(cartLine: CartLine) {
    if (!cartLine.price_per_piece) return '00.00';
    let priceCalculated =  Number.parseFloat(cartLine.price_per_piece) * cartLine.quantity
    let fixedPrice = priceCalculated.toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  makeReview(product: CartLine) {
    let reviewForm = this._reviewForms[product.uuid]
    if (!reviewForm.get('rating')?.value) {
      this.toastr.error(Errors.bg.ratingNotFilled);
      return;
    }
    const createReviewRequestModel: CreateReviewRequestModel = {
      rating: reviewForm.get('rating')?.value,
      review: reviewForm.get('review')?.value || ' '
    }
    this.reviewsService.postProductReview(product.sku.product.uuid, createReviewRequestModel).subscribe(() => {
      this.removeReviewedCartLine(product.uuid)
      this.toastr.success(Successes[this._language].reviewUpload)
    })
  }

  onRateChanged(rate: any, productUUID: string) {
    let reviewForm = this._reviewForms[productUUID]
    reviewForm.get('rating')?.setValue(rate);
    reviewForm.markAsTouched();
    reviewForm.markAsDirty();
  }

  onReviewChanged(reviewEvent: any, productUUID: string) {
    let reviewForm = this._reviewForms[productUUID]
    reviewForm.get('review')?.setValue(reviewEvent.target.value);
  }

}
